<template>
  <liste-documents
    :categorie="categorie"
    :title="$t('menu.documents.consultations')"
  />
</template>

<script>
export default {
  props: {
    categorie: {
      type: String,
    },
  },
}
</script>
